// SLO Configuration Constants
export const SLO_DEFAULTS = {
    AVAILABILITY_PERCENT: "99",
    LATENCY_PERCENT: "95",
    LATENCY_SECONDS: "1",
    CUSTOM_SLO_NAME_PREFIX: "custom-slo"
};

export const EXAMPLE_QUERIES = {
    HTTP: {
        totalQuery: `http_requests_total{app="{{ .App }}", cid="{{ .Cluster }}"}`,
        successQuery: `http_requests_total{app="{{ .App }}", cid="{{ .Cluster }}", code!~"5.."}`,
        latencyTotalQuery: `http_request_duration_seconds_bucket{app="{{ .App }}", cid="{{ .Cluster }}", le="+Inf"}`,
        latencySuccessQuery: `http_request_duration_seconds_bucket{app="{{ .App }}", cid="{{ .Cluster }}", le="0.5"}`
    },
    GRPC: {
        totalQuery: `grpc_server_handled_total{app="{{ .App }}", cid="{{ .Cluster }}"}`,
        successQuery: `grpc_server_handled_total{app="{{ .App }}", cid="{{ .Cluster }}", grpc_code="OK"}`,
        latencyTotalQuery: `grpc_server_handling_seconds_bucket{app="{{ .App }}", cid="{{ .Cluster }}", le="+Inf"}`,
        latencySuccessQuery: `grpc_server_handling_seconds_bucket{app="{{ .App }}", cid="{{ .Cluster }}", le="0.5"}`
    }
};

export const VALID_SECONDS = [
    "0.005", "0.01", "0.025", "0.05", "0.1", 
    "0.25", "0.5", "1", "2.5", "5", "10", "20", "60", "+Inf"
];

// Helper functions
export const createDefaultLatencyObjective = () => ({
    percent: SLO_DEFAULTS.LATENCY_PERCENT,
    seconds: SLO_DEFAULTS.LATENCY_SECONDS
});

export const createDefaultAvailabilityObjective = () => ({
    percent: SLO_DEFAULTS.AVAILABILITY_PERCENT
});

export const createDefaultCustomSlo = (name: string) => ({
    name,
    availability: {
        percent: SLO_DEFAULTS.AVAILABILITY_PERCENT,
        totalQuery: "",
        successQuery: ""
    }
});
